import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

const AppBarStyled = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'openLeft'
})(({ theme, openLeft }) => ({
  zIndex: theme.zIndex.drawer + 1, // L'header starà sempre SOPRA i drawer

  transition: theme.transitions.create(['left', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),

  left: openLeft ? DRAWER_WIDTH : MINI_DRAWER_WIDTH,
  right: 0, // Fissato al bordo destro
  width: 'auto',

  ...(openLeft && {
    transition: theme.transitions.create(['left', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  })
}));

export default AppBarStyled;